import { Outlet } from 'react-router-dom';

export default function AuthLayout() {
  return (
    <div className="flex min-h-screen items-center justify-center p-4 bg-neutral-100 dark:bg-neutral-800">
      <div className="w-full max-w-md bg-white dark:bg-neutral-900 rounded-3xl shadow-xl shadow-neutral-200/50 p-8 border border-neutral-200 dark:border-neutral-800">
        <div className="flex flex-col items-center mb-8">
          <div className="w-12 h-12 bg-neutral-900 rounded-2xl flex items-center justify-center mb-4">
            <span className="text-white font-bold text-xl">M</span>
          </div>
          <h1 className="text-2xl font-bold tracking-tight">Messego</h1>
          <p className="text-neutral-500 dark:text-neutral-400 text-sm">Unified platform for everything</p>
        </div>
        <Outlet />
      </div>
    </div>
  );
}
